// extracted by mini-css-extract-plugin
module.exports = {"btn":"SetRateActive_btn__1gLO-"};